import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { WORK_WITH_US } from '../../config/links/links';
import ThemeContext from '../../providers/ThemeProvider';

const AdvertiseLink = ({ isMobileHidden }) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames('advertise-link-container', {
    'advertise-link-container--hidden-mobile': isMobileHidden,
  });

  return (
    <div className={componentClass}>
      <a
        aria-label="Advertise Link"
        data-qa="advertiseLink"
        href={WORK_WITH_US}
        rel="noreferrer noopener"
        target="_blank"
      >
        Advertise
      </a>
      <style jsx>{`
        .advertise-link-container a {
          text-align: center;
          color: ${theme.colors.headerprimary};
          font-size: 12px;
        }

        .advertise-link-container a:hover {
          text-decoration: none;
        }

        @media (max-width: ${theme.breakpoints.mdDown}) {
          .advertise-link-container--hidden-mobile {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};

export default AdvertiseLink;

AdvertiseLink.propTypes = {
  isMobileHidden: PropTypes.bool,
};
